import React, { Component } from "react";
import { HashRouter, Switch } from "react-router-dom";
import { request, apis } from "./utils/net"

import axios from 'axios';
import "./app.less";
import { Provider } from "mobx-react";
import stores from "./stores"; //引入所有store
import IndexStore from '@/stores/store';
import MtaH5 from "mta-h5-analysis";
import { Modal } from 'antd'
import routeConfig from './route.config'
import { generateRoutes } from '@/utils/router'
import fetchJsonp from 'fetch-jsonp'
import pubsub from "pubsub-js"
import appStore from './stores/store'

const Routes = generateRoutes(routeConfig)

let timer
class App extends Component {
    constructor(prpos) {
        super(prpos);

        // 初始化统计
        MtaH5.init({
            sid: "500595047", //必填，统计用的appid
            cid: "500599607", //如果开启自定义事件，此项目为必填，否则不填
            autoReport: 1, //是否开启自动上报(1:init完成则上报一次,0:使用pgv方法才上报)
            senseHash: 0, //hash锚点是否进入url统计
            senseQuery: 0, //url参数是否进入url统计
            performanceMonitor: 0, //是否开启性能监控
            ignoreParams: [] //开启url参数上报时，可忽略部分参数拼接上报
        });
    }

    componentWillMount() {
        pubsub.subscribe("load-start", () => {
            appStore.loading = true
        });
        pubsub.subscribe("load-end", () => {
            appStore.loading = false
        });
    }

    componentDidMount() {
        // 从服务器返回的标准时间，用于解决客户机时间不准问题
        request({
            needToken: false,
            url: apis.getServerDate
        }).then(timestamp => {
            // 服务器时间与用户本地时间时间差，当时间差超过1小时提示用户本地时间有误
            const gap = Math.abs(timestamp * 1000 - new Date().getTime())
            if (gap > (1000 * 60 * 60)) {
                Modal.error({
                    title: '提示',
                    content: '系统检测到您当前电脑系统时间跟商户平台服务端不一致，请检查并调整您的电脑时间'
                })
            }
        });
        // http://kpserverdev-1251506165.cossh.myqcloud.com/maintain/main.json
        // request({
        //     needToken: false,
        //     method: 'GET',
        //     baseURL: 'http://kpserverdev-1251506165.cossh.myqcloud.com/maintain/main.json',
        //     unforeseen: res => {
        //     }
        // }).then(res => {
        // });
        this.longpoll()
    }

    // 紧急维护弹出窗
    longpoll = () => {
        const queryFile = process.env.NODE_ENV === 'production' ? 'main.json' : 'main.dev.json'
        fetchJsonp(`https://kpserverdev-1251506165.cossh.myqcloud.com/maintain/${queryFile}`).then(res => {
            const arr = res.data || [{}]
            const newArr = arr.find(item => item.platform === '1') || {}
            const begin_at = new Date(newArr.date_range[0]).getTime()
            const end_at = new Date(newArr.date_range[1]).getTime()
            const dateType = begin_at <= new Date().getTime() && new Date().getTime() <= end_at
            if (newArr.enable && dateType) {
                IndexStore.updateNotice = newArr
                // history.push('/update-notice')
                Modal.error({
                    title: '提示',
                    content: `因${newArr.content}，维护时长${newArr.date_range[0]}—${newArr.date_range[1]}维护期间无法使用，敬请谅解`
                })
                return clearTimeout(timer)
            }
        }).catch(err => {
            console.log(err)
        })
        timer = setTimeout(() => {
            this.longpoll()
        }, 5000)
    }
    componentWillUnmount() {
        clearTimeout(timer)
    }

    render() {
        return (
            <Provider {...stores}>
                <HashRouter getUserConfirmation={(message, callback) => {
                    // 自定义路由跳转离开前确认弹框界面
                    Modal.confirm({
                        title: '提示',
                        content: message,
                        onCancel: () => {
                            callback(false)
                        },
                        onOk: () => {
                            callback(true)
                        }
                    })
                }}>
                    <Switch>
                        { Routes }
                    </Switch>
                </HashRouter>
            </Provider>
        );
    }
}

export default App;
